export default __webpack_public_path__ + "public/assets/images/9aa2566bad3888bee2af377702d8a961.png";